export default __webpack_public_path__ + "07df39027d5dbdf11ddb85e7023595d2.png";